import { VerticalPaginatedList } from 'components/vertical-paginated-list/vertical-paginated-list'
import { UserPermissionHeader } from 'components/user/user-permission-header/user-permission-header'
import { useState } from 'react'
import { Avatar } from 'components/avatar/avatar'
import { useTranslate } from 'utils'
import { CrownOutlined, RightOutlined } from '@ant-design/icons'
import { useLocations } from 'api'
import { VerticalContainer } from 'components/styled'
import { Search } from 'components/search/search'
import { theme } from 'antd'

type Props = {
    onSelect: (id: string | null) => void
    onBack: () => void
}

export const UserPermissionLocationSelect = ({ onSelect, onBack }: Props) => {

    //hooks:
    const { __ } = useTranslate()
    const { token: { fontSizeSM, fontSizeLG, margin, paddingXS, paddingLG } } = theme.useToken()
    const [ search, setSearch ] = useState<string | null>(null)
    
    const {
        data: locations,
        pageNum,
        totalPages,
        isLoading,
        isPreviousData,
        isNextDisabled,
        isPreviousDisabled,
        fetchNext,
        fetchPrevious
    } = useLocations(search)

    return (
        <VerticalContainer style={{ height: '100%', paddingBottom: paddingXS, gap: margin }}>

            <VerticalContainer>

                {/* header */}
                <UserPermissionHeader
                    title={__`location`}
                    onBack={onBack}
                >
                    <Search
                        placeholder={__`search_locations`}
                        onSearch={setSearch}
                    />
                </UserPermissionHeader>

            </VerticalContainer>

            <VerticalPaginatedList
                isFirstLoading={isLoading}
                isForbidden={locations === null}
                isError={locations === false}
                notFound={(locations && locations.length === 0) ?? false}
                pageNum={pageNum}
                totalPages={totalPages}
                isPreviousData={isPreviousData}
                isNextDisabled={isNextDisabled}
                isPreviousDisabled={isPreviousDisabled}
                scrollable={true}
                fetchNext={fetchNext}
                fetchPrevious={fetchPrevious}
            >

                <Avatar
                    name={__`all`}
                    image={null}
                    placeholder={<CrownOutlined style={{ fontSize: fontSizeLG }}/>}
                    backgroundColor='transparent'
                    description={__`access_to_all_locations`}
                    extraIcon={<RightOutlined style={{ fontSize: fontSizeSM }}/>}
                    style={{ width: '100%', paddingLeft: paddingLG, paddingRight: paddingLG, borderRadius: 0 }}
                    onClick={() => onSelect(null)}
                />

                    {locations && locations.map(location => (
                        <Avatar
                            key={location.id}
                            name={location.name}
                            image={location.image.path}
                            description={location.email}
                            extraIcon={<RightOutlined style={{ fontSize: fontSizeSM }}/>}
                            style={{ width: '100%', paddingLeft: paddingLG, paddingRight: paddingLG, borderRadius: 0 }}
                            onClick={() => onSelect(location.id)}
                        />
                    ))}

            </VerticalPaginatedList>

        </VerticalContainer>
    )

}
